import {
  Box,
  Heading,
  Text,
  Stack,
  Avatar,
  Badge,
  Spinner,
  Center,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { ElementType, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Employee } from "../utils/types";
import { getEmployeeData, getEmployeeDataMe, getEmployees } from "../hooks/employees";
import { EditIcon } from "lucide-react";
import { FiBriefcase, FiPhone, FiMail, FiCalendar } from "react-icons/fi";

const ViewEmployeePage = () => {
  const { orgId, teamMemberId } = useParams();
  const [employee, setEmployee] = useState<Employee | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const response = await getEmployeeData(orgId,teamMemberId || "");
        console.log('Employee response', response?.data);
        setEmployee(response?.data);
      } catch (err) {
        console.error("Failed to fetch team member data", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEmployee();
  }, [teamMemberId]);

  
  
  if (loading) {
    return (
      <Center py={20}>
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!employee || !employee.user) {
    return (
      <Center py={20}>
        <Text color="red.500">Team member not found.</Text>
      </Center>
    );
  }

  return (
    <Box
      maxW="lg"
      mx="auto"
      mt={10}
      p={8}
      bgGradient="linear(to-br, white, green.50)"
      borderWidth="1px"
      borderRadius="2xl"
      boxShadow="lg"
      transition="all 0.3s ease"
      _hover={{ transform: "scale(1.02)", boxShadow: "xl" }}
    >
      {/* Top Section - Avatar + Info */}
      <HStack spacing={5} align="center">
        <Avatar
          size="xl"
          name={employee.user.first_name}
          // src={employee.user.profile_picture}
          bg="green.100"
          color="green.700"
          shadow="md"
        />

        <VStack align="start" spacing={1}>
          <Heading size="md" color="green.800">
            {employee.user.first_name}
          </Heading>
          <Text fontSize="sm" color="gray.600">
            {employee.user.email}
          </Text>

          <Badge
            mt={1}
            px={3}
            py={1}
            borderRadius="full"
            colorScheme="green"
            fontWeight="medium"
          >
            {employee.role || "No Role Assigned"}
          </Badge>
        </VStack>
      </HStack>

      {/* Divider */}
      <Divider my={6} />

      {/* Organization Section */}
      <Box>
        <Text fontWeight="bold" color="gray.700" mb={1}>
          Organization
        </Text>
        <HStack>
          <Icon as={FiBriefcase as ElementType} color="green.600" />
          <Text color="gray.700" fontSize="sm">
            {employee?.organization?.name || "No organization assigned"}
          </Text>
        </HStack>
      </Box>

      <Box mt={5}>
        <Text fontWeight="bold" color="gray.700" mb={1}>
          Date Joined
        </Text>
        <HStack>
          <Icon as={FiCalendar as ElementType} color="green.600" />
          <Text color="gray.700" fontSize="sm">
            {employee?.date_joined}
          </Text>
        </HStack>
      </Box>

      {/* Contact Info */}
      <Box mt={5}>
        <Text fontWeight="bold" color="gray.700" mb={2}>
          Contact Details
        </Text>
        <VStack align="start" spacing={2}>
          {/* {employee.user?.phone && (
            <HStack color="gray.700">
              <Icon as={FiPhone} color="green.600" />
              <Text fontSize="sm">{employee.user.phone}</Text>
            </HStack>
          )} */}
          {employee.user?.email && (
            <HStack color="gray.700">
              <Icon as={FiMail as ElementType} color="green.600" />
              <Text fontSize="sm">{employee.user.email}</Text>
            </HStack>
          )}
        </VStack>
      </Box>

      {/* Footer */}
      <Flex mt={6} justify="flex-end">
        <Button
          size="sm"
          colorScheme="green"
          bg={"#006400"}
          variant="solid"
          leftIcon={<EditIcon />}
          borderRadius="lg"
          px={5}
          shadow="sm"
          onClick={() => navigate(`/organization/${orgId}/team/${employee.id}/edit`)}
        >
          Edit Profile
        </Button>
      </Flex>
    </Box>

  );
};

export default ViewEmployeePage;
